/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
	APIendpoint: 'https://talabservicescollaudo.it:8443',
  //APIendpoint: 'https://questionariopis.unisa.it:8445',
  cruscottiLink : 'https://idcs-3caaf6d36aa4453d85f134a7510b5cef.identity.oraclecloud.com/sso/v1/app/launcher/b9c52ab710af46868117dba2c30641b0',
  richiesteAcquistoLink : 'https://fa-eukn-test-saasfaprod1.fa.ocs.oraclecloud.com/fscmUI/faces/FndOverview?fndGlobalItemNodeId=itemNode_my_information_purchase_requisitions',
  //APIendpoint: 'http://localhost:8080',
  incarichi_pass: 1,
  autocertificazioni_pass: 1,
  gestione_utenti_pass: 1,
  epm_pass: 1,
  presenze_pass: 1,
  scatti_pass: 1,
  placement_pass: 1,
  portali_didattica_pass: 1,
  pregetti_unisa_pass: 1,
	registri_pass: 1,
  allocazione_stipendi_pass: 1,
  allocazione_tasse_pass: 1,
  decreti_liquid_pass: 1,
  strutture_pass: 1,
  trasferimento_budget_pass: 1,
  rendicontazione_pass: 1,
  gestione_compensi_pass: 1,
  versamenti_ritenute_pass: 1,
  buoni_carico_scarico_pass: 1,
  contabilita_pass: 1,
  questionari_pass: 1,
  richieste_acquisto_pass: 1,
  bandi_concorsi_pass: 1,
  APIPlacementEndopoint: 'https://talabservicescollaudo.it:8443',
};
